import styled, { css } from "styled-components";
import colours from "../../assets/colours";

const Container = styled.div`
  background: ${colours.white};
  color: ${colours.grey2};
  box-shadow: 10px 10px 45px rgba(108,109,133, 0.15);
  border-radius: 20px;

  ${({ variant }) =>
    variant &&
    css`
      background: ${colours[variant]};
      color: ${colours.chablis};
    `}
`;

export { Container };
